import BaseClass from "./BaseClass";
import PaginationArrows from "./pagination/PaginationArrows";

const defaultOptions = {};

export default class Review extends BaseClass {

    /**
     * Constructor
     *
     * @param options
     */
    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {
        let ratings = {};
        let isEditReview = false;

        $(document).ready(function () {
            if ($("[data-stepTwoButton]").length > 0) {
                isEditReview = $("input[name='reviewID']").val() !== "";

                if (isEditReview) {
                    $("[data-stepTwoButton]")[0].disabled = false;
                }
            }

            // count characters in textarea
            $('#review-textarea').keyup(function () {
                let characterCount = $(this).val().length;
                let currentCount = $('#current_count');
                let maximumCount = $('#maximum_count');
                let maximumCountValue = $(maximumCount).html().split("/")[1];
                currentCount.text(characterCount);

                if (characterCount >= maximumCountValue) {
                    currentCount.removeClass('grey');
                    maximumCount.removeClass('grey');
                    currentCount.addClass('red');
                    maximumCount.addClass('red');
                } else {
                    currentCount.removeClass('red');
                    maximumCount.removeClass('red');
                    currentCount.addClass('grey');
                    maximumCount.addClass('grey');
                }
            });

            $("#review_paginator_step_2").click(function () {
                leaveReviewStepTwo();
            })

            $("#review_paginator_step_1").click(function () {
                leaveReviewStepOne();
            })

            // Add active class to selected rating value
            $(".rating-category-list-item").click(function () {
                $(this).addClass('active');
                $(this).siblings('li').removeClass('active');
                $("input[name='"+$(this).data('rating')+"']").val($(this).text());
                ratings[$(this).data('rating')] = true;

                // if all ratings has been selected allow clicking on button
                if (isEditReview) {
                    $("[data-stepTwoButton]")[0].disabled = false;
                } else {
                    if (Object.keys(ratings).length == $(".rating-category-list").length) {
                        $("[data-stepTwoButton]")[0].disabled = false;
                    } else {
                        $("[data-stepTwoButton]")[0].disabled = true;
                    }
                }
            })

            // pagination arrows in latest reviews
            $(document).ready(() => {
                $('[data-paginationarrows="reviews"]').each((i, e) => {
                    new PaginationArrows($(e));
                })
            })
        })
    }

    /**
     * Function that likes review if logged in
     *
     * @param {Element} e clicked element
     * @param {Integer} reviewID review id
     */
    likeReview(e, reviewID)
    {
        let url = $(e).data('href');

        $.ajax({
            headers: {'X-App-Locale': $('[name="country"]').attr('content'),},
            type: 'POST',
            url: url,
            data: {
                review_id: reviewID,
                "_token": $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                let count = parseInt(data);
                let likeTranslation = '';
                if (count == 1) {
                    likeTranslation = $(e).data('singularTranslation');
                } else {
                    likeTranslation = $(e).data('pluralTranslation');
                }

                $("[data-name='review_span_" + reviewID + "']").html(count + ' ' + likeTranslation);
                $("[data-like-id='"+ reviewID + "']").toggleClass('liked');
            }
        })
    }

    /**
     * Function that hides step two and shows step one
     */
    leaveReviewStepOne()
    {
        $("[data-stepOne]").show();
        $("[data-stepTwo]").hide();
        $("[data-circleStepTwo]").removeClass('active');
        $("[data-circleStepOne]").addClass('active');
    }

    /**
     * Function that hides step one and shows step two
     *
     * It also calls ajax to store review to Session
     */
    leaveReviewStepTwo()
    {
        let title = $("input[name='title']").val();
        let description = $("textarea[name='description']").val();
        let bookingID = $("input[name='bookingID']").val();
        let bookingCheckout = $("input[name='bookingCheckout']").val();
        let hotelID = $("input[name='hotelID']").val();
        let reviewID = $("input[name='reviewID']").val();
        let descriptionErrorMessage = $("#description-textarea-error-message")

        if (description !== '') {
            $("textarea[name='description']").removeClass('error');
            descriptionErrorMessage.hide();

            $("[data-stepOne]").hide();
            $("[data-stepTwo]").show();
            $("[data-circleStepTwo]").addClass('active');
        } else {
            $("textarea[name='description']").addClass('error');
            descriptionErrorMessage.show();
        }
    }

    /**
     * Function that calls ajax to store review and redirects back to user reviews page
     *
     * @param {Element} e clicked button
     */
    publishReview(e)
    {
        $(e)[0].disabled = true;
        let ratingsInputs = $("[data-ratingForDB]");
        let ratings = {};
        let bookingID = $("input[name='bookingID']").val();
        let emailToken = $("input[name='emailToken']").val();
        let title = $("input[name='title']").val();
        let description = $("textarea[name='description']").val();
        let reviewURL = $('input[name="review-thank-url"]').val();
        let captchaInput = $('#recaptcha-token');

        $('[data-recaptchaError]').hide();

        ratingsInputs.each(function (i, e) {
            ratings[$(e).data('category')] = $(e).val();
        });

        $.ajax({
            headers: {
                'X-App-Locale': $('[name="country"]').attr('content'),
            },
            type: "POST",
            url: window.location.origin + '/save-review',
            data: {
                bookingID,
                emailToken,
                title,
                description,
                ratings: ratings,
                captcha: captchaInput.val(),
            },
            success: function (data) {
                if (data.length > 0) {
                    let dataObj = JSON.parse(data);
                    if (dataObj['captchaError']) {
                        $('[data-recaptchaError]').show();
                        return;
                    }
                }

                window.location = reviewURL + "?bookingID="+bookingID;

                recaptcha((token) => {
                    captchaInput.val(token);
                });
            }
        })

        recaptcha((token) => {
            captchaInput.val(token);
        });
    }

    /**
     * Function that deletes review
     */
    deleteReview()
    {
        let ID = $("input[name='delete_review']").val();

        if (ID !== undefined) {
            $.ajax({
                headers: {
                    'X-App-Locale': $('[name="country"]').attr('content'),
                },
                type: "POST",
                url: window.location.origin + '/delete-review',
                data: {
                    ID: ID
                },
                success: function (data) {
                    window.location.reload()
                }
            })
        }
    }
}
